<template>
  <div>
    <van-nav-bar
      title="平台公告"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <div style="padding: 0px 10px; margin-top: 10px">
      <van-loading
        v-if="isLoading"
        style="text-align: center; padding-top: 20px"
        >加载中...</van-loading
      >
     
        <div v-for="(item, index) in announceList" :key="index">
        <van-row class="contentBg">
          <van-row style="display: flex; align-items: center">
            <span> <img src="../assets/images/announcement.png" alt=""></span>
            <span class="datetext">{{ item.time }}</span>
            <span class="title">{{ item.name }}</span>
          </van-row>
          <van-divider dashed :style="{ borderColor: 'black' }" />
          <!-- <van-row style="color: #a6a6a6; font-size: 13px">
            {{ item.content }}
          </van-row> -->
          <van-row style="color: black; font-size: 13px">
            {{ stripHTML(item.content) }}
          </van-row>

        </van-row>
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: "Announcement",
  data() {
    return {
      announceList: [],
      isLoading: false,
    };
  },
  methods: {
    stripHTML(html) {
      return html.replace(/<\/?[^>]+(>|$)/g, ""); // Removes HTML tags
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getList() {
      let that = this;
      that.isLoading = true;
      that
        .$http({
          url: "/",
          method: "POST",
          data: {
            nozzle: "notice",
            token: sessionStorage.getItem("token"),
          },
        })
        .then((ret) => {
          that.isLoading = false;
          let resData = ret.data;
          if (resData.code === 1) {
            that.announceList = resData.data;
          } else {
            that.$toast.fail(resData.msg);
          }
        })  
        .catch(()=>{
          that.isLoading = false; 
        });
    },
    showAboutUsContent(item) {
      this.$store.state.announcement_title = item.name;
      this.$store.state.announcement_content = item.content;
      this.$router.push({
        path: "/member/announcement_detailed",
      });
    },
  },
  mounted: function () {
    let that = this;
    this.isLogin();
    this.getList();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.title {
  margin: 2px 5px;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.contentBg {
  background: #f0f0f0;
  border-radius: 15px;
  padding: 20px 10px;
  margin: 10px 20px;
}
.contentBg img {
  width: 20px;  
  height: 20x; 
  margin-right: 5px; 
  margin-top: -2px;
}
.datetext {
  color: #333333;
  padding-left: 5px;
  font-size: 15px;
  font-weight: 700;
}
</style>


// WEBPACK FOOTER //
// src/components/Announcement.vue